export function DefaultSkeleton() {
  return (
    <div className="max-w-full animate-pulse">
      <div className="mb-4 block h-3 w-56 rounded-full bg-gray-300 font-sans text-5xl font-semibold leading-tight tracking-normal text-inherit antialiased">
        &nbsp;
      </div>
      <div className="mb-2 block h-2 w-72 rounded-full bg-gray-300 font-sans text-base font-light leading-relaxed text-inherit antialiased">
        &nbsp;
      </div>
      <div className="mb-2 block h-2 w-72 rounded-full bg-gray-300 font-sans text-base font-light leading-relaxed text-inherit antialiased">
        &nbsp;
      </div>
      <div className="mb-2 block h-2 w-72 rounded-full bg-gray-300 font-sans text-base font-light leading-relaxed text-inherit antialiased">
        &nbsp;
      </div>
      <div className="mb-2 block h-2 w-72 rounded-full bg-gray-300 font-sans text-base font-light leading-relaxed text-inherit antialiased">
        &nbsp;
      </div>
    </div>
  );
}
